import { Component } from '@angular/core';
import { VisitService } from '../services/visit.service';
import { Visit } from '../models/visit.model';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { AssesmentFormService } from '../services/assesment.form.service';

import { Location } from '@angular/common';

@Component({
  selector: 'app-print-medical-report',
  templateUrl: './print-medical-report.component.html'
})
export class PrintMedicalReportComponent {

  constructor(private location: Location, private route: ActivatedRoute, public service: VisitService, public assesmentFormService: AssesmentFormService, private notificationService: NotificationService) { }

  model: Visit;
  id: string;

  ngOnInit() {

    if (this.route.snapshot.paramMap.has('id')) {
      this.id = this.route.snapshot.paramMap.get('id');

      this.service.get(this.id).subscribe(
        res => {
          this.model = res as Visit;
        },
        err => { console.log(err); this.notificationService.notifyFailure(); }
      );

    }

  }

  goBack(): void {
    this.location.back();
  }
}

